import React from 'react';
import { withRouter } from 'react-router-dom';
import { Grid } from '@material-ui/core';

import StyledNavLink from '../../ux/StyledNavLink';

class SidePanel extends React.Component {
  render() {
    return (
      <Grid
        container
        direction="column"
        justify="flex-start"
        alignItems="flex-start"
        spacing={3}
        style={{
          background: 'white',
          fontWeight: '400',
          fontSize: 13,
          padding: '18px 16px',
          border: '1px solid #e2e7f0',
          borderRadius: 16,
          boxShadow: '0 2px 6px rgba(17, 25, 54, 0.05)',
          position: 'sticky',
          top: 20,
        }}
      >
        <Grid item>
          <StyledNavLink
            to={`/influencer/campaigns/${this.props.match.params.campaignId}/feeds/${this.props.match.params.influencerId}/youtube`}
            label={'YouTube Feeds'}
          />
        </Grid>
        <Grid item>
          <StyledNavLink
            to={`/influencer/campaigns/${this.props.match.params.campaignId}/feeds/${this.props.match.params.influencerId}/instagram`}
            label={'Instagram Feeds'}
          />
        </Grid>
      </Grid>
    );
  }
}

export default withRouter(SidePanel);
